// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2-JEB","buttons":"styles_buttons__IXpWY"};